import { SessionArticleEvent } from '../ISessionEvent';

export class DictionaryLookupEvent extends SessionArticleEvent {
  constructor(articleId: string, word: string) {
    super('dictionary-lookup', articleId, {
      word,
    });
  }
}
